<script>
import { useCheckoutStore } from "@/store/checkout";
import { mapState } from "pinia";

import ProduitsIncompatiblesForm from "@/containers/produits-incompatibles-form";
import ProduitsToListeForm from "@/containers/shipping-method/move-produits-to-liste-form";
import Popin from "@/components/molecules/popin";

export default {
  components: {
    ProduitsIncompatiblesForm,
    ProduitsToListeForm,
    Popin
  },
  data() {
    return {
      popinProduitsToListeVisible: false
    };
  },
  computed: {
    ...mapState(useCheckoutStore, ["produitsIncompatibles"])
  },
  methods: {
    setPopinProduitsToListeVisible(visible) {
      this.popinProduitsToListeVisible = visible;
    },
    redirectToTunnel() {
      this.setPopinProduitsToListeVisible(false);
      navigateToInternal("/commander");
    }
  }
};
</script>

<template>
  <div>
    <ProduitsIncompatiblesForm @addToListe="setPopinProduitsToListeVisible(true)" />
    <Popin
      :visible="popinProduitsToListeVisible"
      aria-label="Produits incompatibles"
      slide-up
      @hidden="setPopinProduitsToListeVisible(false)"
    >
      <ProduitsToListeForm
        :produits="produitsIncompatibles"
        @saved="redirectToTunnel"
      />
    </Popin>
  </div>
</template>
